import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

import MBFLogo from '../../utilities/dummy_assets/MBF_Logo.png';
import MapITLogo from '../../utilities/dummy_assets/mapITlogo.png';
import background from '../../utilities/dummy_assets/background.png';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import Logos from '../../components/logos';
import { toast } from 'react-toastify';

const Capture = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [imageData, setImageData] = useState(null);
  const [stream, setStream] = useState(null);
  const navigate = useNavigate();
  const [hasCameraPermission, setHasCameraPermission] = useState(null);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    if (hasCameraPermission === null || hasCameraPermission) {
      startCamera();
    }
    return () => {
      stopCamera();
    };
  }, [hasCameraPermission]);

  const startCamera = async () => {
    try {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(t => t.stop());
        videoRef.current.srcObject = null;
      }

      const currentStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });

      if (videoRef.current) {
        const video = videoRef.current;
        video.srcObject = currentStream;

        video.onloadedmetadata = async () => {
          try {
            await video.play();
          } catch (error) {
            console.error('Error playing video:', error);
            toast.error(
              'Unable to start video playback. Please check your camera and browser settings.'
            );
          } finally {
            setLoader(false);
          }
        };
      }

      setStream(currentStream);
      setHasCameraPermission(true);

      currentStream.getVideoTracks()[0].onended = () => {
        setHasCameraPermission(false);
        setStream(null);
        if (videoRef.current) videoRef.current.srcObject = null;
      };
    } catch (err) {
      console.error('Error accessing webcam:', err);
      setLoader(false);
      setHasCameraPermission(false);
      setStream(null);
      if (err.name !== 'NotAllowedError') {
        toast.error(
          'An error occurred while accessing the camera. Please try again.'
        );
      }
    }
  };

  const stopCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop());
    }
  };

  const captureImage = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    const context = canvas.getContext('2d');
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL('image/png');
    setImageData(dataUrl);
    stopCamera();
  };

  const handleRetake = () => {
    setImageData(null);
    startCamera();
  };

  // const handleUpload = () => {
  //   navigate('/position-enter', { state: { capturedImage: imageData } });
  // };
  const handleUpload = () => {
    navigate('/register-submit-1', { state: { capturedImage: imageData } });
  };
  return (
    <Box
      sx={{
        // width: "100vw",
        minHeight: '100vh',
        // overflow: "hidden",
        display: 'flex',
        // justifyContent: "center",
        // alignItems: "center",
        backgroundImage: { sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        // padding: "1rem",
        boxSizing: 'border-box',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          p: '16px 12px',
        }}
      >
        <span
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/login')
          }
          style={{
            color: 'var(--Accent-Accent-01, #0062CC)',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontSize: { xs: '12px', sm: '16px' },
          }}
        >
          Go to Student Site
        </span>
      </Box>

      {/* Main Capture UI */}
      <Box
        sx={{
          backgroundColor: 'white',
          borderRadius: '20px',
          padding: '24px',
          width: { sm: '40%' },
          // maxWidth: '700px',
          boxShadow: { sm: '4px 4px 20px rgba(0, 123, 255, 0.1)' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
          margin: 'auto',
        }}
      >
        <Typography variant="h6" fontWeight={600} color="#212121">
          Set Your Profile Photo
        </Typography>

        {!imageData && hasCameraPermission ? (
          <>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{
                width: '100%',
                borderRadius: '12px',
                border: '2px solid #ccc',
              }}
            />
            <Button
              onClick={captureImage}
              variant="contained"
              disabled={!hasCameraPermission || !stream}
              sx={{
                backgroundColor: '#007BFF',
                borderRadius: '10px',
                padding: '10px 20px',
                fontWeight: 600,
                textTransform: 'none',
              }}
            >
              Capture
            </Button>
            <a href="/register-instructions">Back</a>
          </>
        ) : imageData ? (
          <>
            <img
              src={imageData}
              alt="Captured"
              style={{
                width: '60%',
                objectFit: 'cover',
                borderRadius: '12px',
                border: '1px solid #888',
              }}
            />
            <Box sx={{ display: 'flex', gap: '1rem', width: '100%' }}>
              <Button
                onClick={handleRetake}
                variant="outlined"
                sx={{
                  borderRadius: '10px',
                  padding: '8px 20px',
                  textTransform: 'none',
                  flex: 1,
                }}
              >
                Take Again
              </Button>
              <Button
                onClick={handleUpload}
                variant="contained"
                disabled={!imageData}
                sx={{
                  backgroundColor: '#007BFF',
                  borderRadius: '10px',
                  padding: '8px 20px',
                  color: '#fff',
                  fontWeight: 600,
                  textTransform: 'none',
                  flex: 1,
                }}
              >
                Upload
              </Button>
            </Box>
          </>
        ) : loader ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '300px',
            }}
          >
            <Typography>Loading camera...</Typography>
          </Box>
        ) : (
          <Typography color="error">
            Camera access denied. Please grant permission to continue.
          </Typography>
        )}

        <canvas ref={canvasRef} style={{ display: 'none' }} />
      </Box>

      {/* Footer */}
      <Logos />
    </Box>
  );
};

export default Capture;
